/* ==========================================================
   NURÉVE — Bildschicht
   1) findet alle Inhaltsbilder/-videos im Shop
   2) Scroll-Reveal (weiches Einblenden + Settle-Zoom)
   3) dezentes AI-Icon (Quadrat mit "AI") in der rechten unteren Ecke (Art. 50 KI-VO)

   Ausnahme für echte Fotos: im Alt-Text "#echt" ergänzen.
   Das Kürzel wird im Frontend automatisch wieder entfernt.
   Globaler Schalter: window.NRV_AI_LABEL = false deaktiviert die Labels.
   Mini-Vorschaubilder (alles mit "thumb" in der Klasse) bekommen kein Label —
   auch dann nicht, wenn sie beim Laden versteckt sind (z. B. andere Farbvariante).
   ========================================================== */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LABEL_ON = window.NRV_AI_LABEL !== false;
  var root = document.documentElement;
  if(!reduce && 'IntersectionObserver' in window) root.classList.add('nrv-img-motion');

  var SCOPE = 'main img, main video, .nrvf-com-tile img, .nrvf-news-media img, .nrvf-news-media video';
  var EXCLUDE = [
    'header', '.header', '[class*="logo"]', '.payment-icons', '[class*="payment"]',
    '[class*="thumb"]', '[data-nrvhm-thumb]', '.cart-items', 'cart-drawer', '.predictive-search',
    '[data-nrv-no-ai]', '.nrv-no-ai', 'svg'
  ].join(',');
  var FADE_ONLY = '.nrvs-quote-media img, .nrvs-colhead-media img';
  var MIN = 90;

  var io = (!reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      reveal(e.target);
      io.unobserve(e.target);
    });
  }, {rootMargin:'0px 0px -6% 0px', threshold:0.06}) : null;

  function reveal(el){
    el.classList.add('nrv-img-in');
    var host = el.__nrvHost;
    if(host){
      var tag = host.querySelector(':scope > .nrv-ai-tag');
      if(tag) tag.classList.add('nrv-ai-tag--in');
    }
  }

  function isReal(el){
    var alt = (el.getAttribute('alt') || '') + ' ' + (el.getAttribute('title') || '');
    return /#echt\b/i.test(alt);
  }

  function cleanAlt(el){
    var alt = el.getAttribute('alt');
    if(alt && /#echt\b/i.test(alt)){
      el.setAttribute('alt', alt.replace(/\s*#echt\b/ig,'').trim());
    }
  }

  function findHost(el){
    var h = el.parentElement;
    if(!h) return null;
    if(h.tagName === 'PICTURE') h = h.parentElement;
    return h;
  }

  function process(el){
    if(el.__nrvDone) return;
    if(el.closest(EXCLUDE)) { el.__nrvDone = true; return; }
    var w = el.getBoundingClientRect().width;
    if(w > 0 && w < MIN) { el.__nrvDone = true; return; }
    if(el.tagName === 'IMG' && /\.svg(\?|$)/i.test(el.currentSrc || el.src || '')) { el.__nrvDone = true; return; }

    var host = findHost(el);
    if(!host) return;
    el.__nrvDone = true;
    el.__nrvHost = host;

    host.classList.add('nrv-img-host');
    if(getComputedStyle(host).position === 'static') host.classList.add('nrv-img-host--static');
    if(host.closest('product-card, .product-card, .nrvs-card, .nrv-cvn-card, .nrv-arc-card, .card-gallery, .resource-card')) host.classList.add('nrv-img-host--card');

    var cs = getComputedStyle(el);
    if(cs.objectFit === 'cover') el.classList.add('nrv-img--cover');

    var real = isReal(el);
    cleanAlt(el);
    if(LABEL_ON && !real && !host.querySelector(':scope > .nrv-ai-tag')){
      var tag = document.createElement('span');
      var hw = host.getBoundingClientRect().width || w;
      tag.className = 'nrv-ai-tag' + (hw >= 900 ? ' nrv-ai-tag--lg' : '');
      tag.textContent = 'AI';
      tag.title = 'KI-generiert: Dieses Bild wurde mit Künstlicher Intelligenz erstellt.';
      tag.setAttribute('aria-hidden','true');
      host.appendChild(tag);
      if(el.tagName === 'IMG'){
        var alt = el.getAttribute('alt') || '';
        if(!/KI-generiert/i.test(alt)) el.setAttribute('alt', (alt ? alt + ' ' : '') + '(KI-generiertes Bild)');
      } else if(el.tagName === 'VIDEO' && !el.getAttribute('aria-label')){
        el.setAttribute('aria-label','KI-generiertes Video');
      }
    }

    if(!io){ reveal(el); return; }
    el.classList.add('nrv-img-reveal');
    if(el.matches(FADE_ONLY)) el.classList.add('nrv-img-reveal--fade');
    var r = el.getBoundingClientRect();
    if(r.width === 0 && r.height === 0){ reveal(el); return; }
    if(r.top < window.innerHeight * 0.9 && r.bottom > 0){
      el.style.setProperty('--nrv-img-delay', '120ms');
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ reveal(el); }); });
    } else {
      io.observe(el);
    }
  }

  function scan(){
    document.querySelectorAll(SCOPE).forEach(process);
  }

  function failsafe(){
    document.querySelectorAll('.nrv-img-reveal:not(.nrv-img-in)').forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight && r.bottom > 0) reveal(el);
    });
  }

  var t;
  function queue(){ clearTimeout(t); t = setTimeout(scan, 200); }

  function boot(){
    scan();
    setTimeout(failsafe, 1500);
    if('MutationObserver' in window){
      new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){ if(muts[i].addedNodes.length){ queue(); break; } }
      }).observe(document.body, {childList:true, subtree:true});
    }
    window.addEventListener('load', function(){ scan(); failsafe(); });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', queue);
})();
